import { render, staticRenderFns } from "./leftbottomcharts.vue?vue&type=template&id=67c9b35b&scoped=true&"
import script from "./leftbottomcharts.vue?vue&type=script&lang=js&"
export * from "./leftbottomcharts.vue?vue&type=script&lang=js&"
import style0 from "./leftbottomcharts.vue?vue&type=style&index=0&id=67c9b35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9b35b",
  null
  
)

export default component.exports